import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackofficeProispraksiTransformer  {
    _originalTypeClassName = "zERP.BO.BackofficeProispraksiTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackofficeProispraksiTransformer.translate = translateService;
}
this.BackofficeProispraksiTransformerKey = null;
this._key = this.BackofficeProispraksiTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackofficeProispraksiTransformerKey:any;
get BackofficeProispraksiTransformerKey(): any {
    return this._BackofficeProispraksiTransformerKey;
  }
set BackofficeProispraksiTransformerKey(value: any) {
    this._BackofficeProispraksiTransformerKey = value;
    this._key = value;
  }

static CancellationDocumentToProeispraxiDocument(proeispraxiCancellation: any): any{let proeispraxiDocument;
proeispraxiDocument.id = proeispraxiCancellation.id;
proeispraxiDocument.isCancelled = proeispraxiCancellation.isCancelled;
proeispraxiDocument.cancellationUser = proeispraxiCancellation.cancellationUser;
proeispraxiDocument.cancellationDate = proeispraxiCancellation.cancellationDate;
proeispraxiDocument.cancellationPaymentType = proeispraxiCancellation.cancellationPaymentType;
proeispraxiDocument.user = proeispraxiCancellation.user;
proeispraxiDocument.date = proeispraxiCancellation.date;
proeispraxiDocument.paymentType = proeispraxiCancellation.paymentType;
proeispraxiDocument.issuerDepartment = proeispraxiCancellation.issuerDepartment;
proeispraxiDocument.remunerated = proeispraxiCancellation.remunerated;
proeispraxiDocument.creditedDepartment = proeispraxiCancellation.creditedDepartment;
proeispraxiDocument.taxID = proeispraxiCancellation.taxID;
proeispraxiDocument.taxAmount = proeispraxiCancellation.taxAmount;
proeispraxiDocument.cancellationDepartment = proeispraxiCancellation.cancellationDepartment;
proeispraxiDocument.companiesClientId = proeispraxiCancellation.companiesClientId;
proeispraxiDocument.lawyersPartnerClientId = proeispraxiCancellation.lawyersPartnerClientId;
proeispraxiDocument.lawyersClientId = proeispraxiCancellation.lawyersClientId;
proeispraxiDocument.receiptNo = proeispraxiCancellation.receiptNo;
proeispraxiDocument.receiptCorrectionDate = proeispraxiCancellation.receiptCorrectionDate;
proeispraxiDocument.proeispraxeisDetails = proeispraxiCancellation.proeispraxeisDetails;
return proeispraxiDocument;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackofficeProispraksiTransformerKey == null || $this.BackofficeProispraksiTransformerKey == 0;
            }


}